import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Paper from '@material-ui/core/Paper';
import './InfoBox.css';

const InfoBox = (props) => {
  const styles = {
    container: {
      backgroundColor: props.color
    },
    iconSpan: {
      backgroundColor: props.color
    },
    icon: {
      iconSize: 64,
      position: 'absolute',
      fill: props.iconColor
    }
  };

  return (
    <Paper style={styles.container} className="icon-boxes-container">
      <span style={styles.iconSpan} className="icon-box-icon-wrapper">
        {props.icon}
      </span>
      <div className="info-box-wrapper">
        <span className="info-box-title">{props.title}</span>
        <span className="info-box-value">{props.value}</span>
        <span className="info-box-subtitle" style={props.subtitle === props.intl.formatMessage({ id: 'Past Due' }) ? { color: 'red' } : undefined}>{props.subtitle}</span>
        <span className="info-box-subvalue" style={props.subtitle === props.intl.formatMessage({ id: 'Past Due' }) ? { color: 'red' } : undefined}>{props.subvalue}</span>
      </div>
    </Paper>
  );
};

InfoBox.propTypes = {
  icon: PropTypes.any,
  iconColor: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subvalue: PropTypes.any,
  value: PropTypes.any
};

export default injectIntl(InfoBox);
